import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";

import "./RoomManagementStyles.scss";
import { user as getUser } from "../../../store/user/userActions";
import {
  listRooms,
  addRoom,
  editRoom,
  archiveRoom,
  setRoomManagementPage,
  clearRoomPaginationState,
} from "../../../store/room/roomActions";
import { list as getlocation } from "../../../store/location/locationActions";
import RoomManagementView from "./RoomManagementView";
import { Loader } from "../../common";

export class RoomManagementContainer extends Component {
  state = {};

  constructor(props) {
    super(props);
    this.props.getUser(true);
    this.props.listRooms({ page: props.roomManagementPage || 1, limit: 5 });
    this.props.getlocation();
  }

  componentWillUnmount() {
    this.props.clearRoomPaginationState();
  }

  handleTabChange = (tabKey) => {
    this.setState({ activeTab: tabKey });
  };

  render() {
    const { userSuccess, roomSuccess, locationSuccess } = this.props;

    if (
      userSuccess === false ||
      roomSuccess === false ||
      locationSuccess === false
    ) {
      return <Loader />;
    }

    return (
      <RoomManagementView
        {...this.props}
      />
    );
  }
}

RoomManagementContainer.propTypes = {
  getUser: PropTypes.func.isRequired,
  listRooms: PropTypes.func.isRequired,
  addRoom: PropTypes.func.isRequired,
  editRoom: PropTypes.func.isRequired,
  archiveRoom: PropTypes.func.isRequired,
  getlocation: PropTypes.func.isRequired,
  userSuccess: PropTypes.bool.isRequired,
  roomSuccess: PropTypes.bool.isRequired,
  locationSuccess: PropTypes.bool.isRequired,
  roomList: PropTypes.array.isRequired,
  locationList: PropTypes.array.isRequired,
  roomPagination: PropTypes.object,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  userSuccess: state.user.userSuccess,
  roomList: state.room.roomList,
  roomSuccess: state.room.roomSuccess,
  roomPending: state.room.roomPending,
  roomPagination: state.room.roomPagination,
  locationList: state.location.locationList,
  locationSuccess: state.location.locationSuccess,
  roomManagementPage: state.room.roomManagementPage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUser,
      listRooms,
      addRoom,
      editRoom,
      archiveRoom,
      getlocation,
      setRoomManagementPage,
      clearRoomPaginationState,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomManagementContainer);
